import { render } from "./EpisodeManagement.vue?vue&type=template&id=ec796a06&ts=true"
import script from "./EpisodeManagement.ts?vue&type=script&lang=ts&external"
export * from "./EpisodeManagement.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__